import invariant from "tiny-invariant";
import { getExternalPlatformIdFromInternalPlatformId } from "@orb-labs/types";
import { LIBRARY_TYPE } from "../enums.js";
import { CHAIN_CONFIGS } from "../constants.js";
import { initializePlatformInformation } from "../utils/utils.js";
export class LibraryRequest {
    constructor(library, client, provider) {
        if (library == LIBRARY_TYPE.VIEM) {
            invariant(client, "CLIENT");
            invariant(!provider, "PROVIDER");
            this.client = client;
        }
        else if (library == LIBRARY_TYPE.ETHERS) {
            invariant(provider, "PROVIDER");
            invariant(!client, "CLIENT");
            this.provider = provider;
        }
        else {
            invariant(false, "LIBRARY");
        }
        this.library = library;
        this.client = client;
        this.provider = provider;
    }
    sendRequest(method, params) {
        if (Object.keys(CHAIN_CONFIGS).length == 0) {
            initializePlatformInformation(this.providerUrl());
        }
        if (this.library == LIBRARY_TYPE.VIEM) {
            return this.client.request({ method, params });
        }
        else if (this.library == LIBRARY_TYPE.ETHERS) {
            return this.provider.send(method, params);
        }
    }
    providerUrl() {
        let url = "";
        if (this.library == LIBRARY_TYPE.VIEM) {
            url = this.client?.transport?.url;
        }
        else if (this.library == LIBRARY_TYPE.ETHERS) {
            url = this.provider._getConnection().url;
        }
        const uuidRegex = /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/i;
        const match = url.match(uuidRegex);
        if (!match)
            return url;
        const endIndex = url.indexOf(match[1]) + match[1].length;
        return url.slice(0, endIndex);
    }
    async formatGasToken(gasToken) {
        if (!gasToken) {
            return undefined;
        }
        const tokenSources = gasToken.tokenSources
            ? await Promise.all(gasToken.tokenSources.map(async ({ platformId, address }) => ({
                platformId: getExternalPlatformIdFromInternalPlatformId(platformId),
                address,
            })))
            : undefined;
        return { ...gasToken, tokenSources };
    }
}
